import { render, staticRenderFns } from "./shopSort.vue?vue&type=template&id=21e6a0b6&scoped=true&"
import script from "./shopSort.vue?vue&type=script&lang=js&"
export * from "./shopSort.vue?vue&type=script&lang=js&"
import style0 from "./shopSort.vue?vue&type=style&index=0&id=21e6a0b6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e6a0b6",
  null
  
)

export default component.exports